var _excluded = ["id", "isOpen", "items", "children", "offsetTop", "disabled", "style", "className", "hoverIndex", "placement", "trigger", "onBlur", "onKeyDown", "onToggle", "onItemSelect", "onHover"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback } from 'react';
import { DropdownMenu } from './DropdownMenu';
import { DropdownPopup } from './DropdownPopup';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Dropdown/DropdownUncontrolled');

/**
 * Выпадающий список с внешнего контроля видимости через props: `isOpen` и `onToggle`.
 */
export var DropdownUncontrolled = function DropdownUncontrolled(_ref) {
  var id = _ref.id,
      isOpen = _ref.isOpen,
      items = _ref.items,
      children = _ref.children,
      offsetTop = _ref.offsetTop,
      disabled = _ref.disabled,
      style = _ref.style,
      className = _ref.className,
      hoverIndex = _ref.hoverIndex,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
      _ref$trigger = _ref.trigger,
      trigger = _ref$trigger === void 0 ? 'click' : _ref$trigger,
      onBlur = _ref.onBlur,
      onKeyDown = _ref.onKeyDown,
      onToggleExternal = _ref.onToggle,
      onItemSelect = _ref.onItemSelect,
      onHover = _ref.onHover,
      rest = _objectWithoutProperties(_ref, _excluded);

  var hasItems = Array.isArray(items) && items.length > 0;
  var onToggle = useCallback(function (newIsOpen, event) {
    if (newIsOpen && hasItems && !disabled) {
      onToggleExternal === null || onToggleExternal === void 0 ? void 0 : onToggleExternal(true, event);
    } else {
      onToggleExternal === null || onToggleExternal === void 0 ? void 0 : onToggleExternal(false, event);
    }
  }, [onToggleExternal, disabled, hasItems]);
  return /*#__PURE__*/React.createElement(DropdownPopup, {
    isOpen: isOpen,
    trigger: trigger,
    placement: placement,
    disclosure: children,
    offsetTop: offsetTop,
    style: style,
    className: className,
    onToggle: onToggle,
    onKeyDown: onKeyDown,
    onBlur: onBlur
  }, /*#__PURE__*/React.createElement(DropdownMenu, _extends({}, rest, {
    id: id,
    items: items,
    hoverIndex: hoverIndex,
    onHover: onHover,
    onItemSelect: onItemSelect
  })));
};